import { useState } from 'react';

const stringToColor = (str = '') => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
    let color = '#';
    for (let i = 0; i < 3; i++) color += (`00${((hash >> (i * 8)) & 0xFF).toString(16)}`).slice(-2);
    return color;
};

const InsuranceLogo = ({ logoUrl, name, size = 24 }) => {
    const [error, setError] = useState(false);

    if (!logoUrl || error) {
        const initials = (name || '?').trim().charAt(0).toUpperCase();
        return (
            <div style={{
                width: size, height: size, borderRadius: '50%',
                backgroundColor: stringToColor(name || ''),
                color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 'bold', fontSize: Math.max(9, Math.round(size * 0.4)), flexShrink: 0,
            }}>
                {initials}
            </div>
        );
    }

    return (
        <img
            src={logoUrl}
            alt={name}
            onError={() => setError(true)}
            style={{
                width: size, height: size, borderRadius: '50%',
                objectFit: 'contain', border: '1px solid #e5e7eb', background: '#fff', flexShrink: 0,
            }}
        />
    );
};

export default InsuranceLogo;
